import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritPartOneVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartOneVehicleInformation/patchCulpritPartOneVehicleInformation.type';

export const patchCulpritPartOneVehicleInformationFunction = ({
  id,
  data,
}: PatchCulpritPartOneVehicleInformationType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/culprit/vehicle_information/part_one/`,
    {
      ...data,
    },
  );
};
